import {
  ButtonCheckbox,
  InputCheckboxChangeEvent,
} from '../../../components/atoms/ButtonCheckbox/ButtonCheckbox';

/**
 * 품절 상품 제외 input
 */
export class ExcludeSoldOutInput extends ButtonCheckbox {
  public static readonly InputChangedEvent = InputCheckboxChangeEvent;
}
